'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactIntl = require('react-intl');
var dateFns = require('date-fns');
var format = require('date-fns/format');
var locale = require('date-fns/locale');
var de = require('date-fns/locale/de');
var fr = require('date-fns/locale/fr');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var format__default = /*#__PURE__*/_interopDefaultLegacy(format);
var de__default = /*#__PURE__*/_interopDefaultLegacy(de);
var fr__default = /*#__PURE__*/_interopDefaultLegacy(fr);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const useCurrencies = () => {
  const { formatNumber } = reactIntl.useIntl();
  return (value, currency = "CHF") => formatNumber(value, {
    style: "currency",
    currency
  });
};

const locales = {
  de: {
    code: "de",
    flag: "\u{1F1E9}\u{1F1EA}",
    name: "Deutsch",
    dateLocale: de__default["default"]
  },
  fr: {
    code: "fr",
    flag: "\u{1F1EB}\u{1F1F7}",
    name: "Fran\xE7ais",
    dateLocale: fr__default["default"]
  }
};

const useFormatDate = () => {
  const { locale } = reactIntl.useIntl();
  return (date, dateFormat = "PP") => format__default["default"](date, dateFormat, {
    locale: locales[locale].dateLocale
  });
};
const normaliseLocalisedDate = (dateString, localeCode = "de") => {
  var _a;
  const cleaned = (_a = dateString.split(",")[1]) == null ? void 0 : _a.trim();
  if (!cleaned)
    return null;
  const locale$1 = localeCode === "fr" ? locale.fr : locale.de;
  const parsed = dateFns.parse(cleaned, "dd.MM.yyyy - HH:mm", /* @__PURE__ */ new Date(), { locale: locale$1 });
  const year = parsed.getFullYear();
  const month = parsed.getMonth();
  const day = parsed.getDate();
  const localDate = new Date(year, month, day, 12, 0, 0);
  const result = format__default["default"](localDate, "yyyy-MM-dd");
  return result;
};

const translations = {
  de: {
    404: {
      headline: "404",
      text: "Diese Seite wurde nicht gefunden."
    },
    header: {
      "main-menu": "Hauptmen\xFC",
      home: "Startseite",
      search: "Suche",
      "my-themes": "Meine Themen",
      "core-knowledge": "Kernwissen",
      menu: "Men\xFC"
    },
    footer: {
      contact: "Kontakt",
      company: "Nuklearforum Schweiz",
      address: "Frohburgstrasse 20",
      city: "4600 Olten",
      tel: "+41 31 560 36 50",
      email: "info@nuklearforum.ch",
      copyright: "Nuklearforum Schweiz \xA9 {year}",
      recommendations: "Unsere Themenempfehlungen"
    },
    meta: {
      sitename: "Nuklearforum Schweiz",
      title_suffix: "Jetzt informieren",
      title: "Kernenergie und Atomkraftwerk",
      description: "Alle Entwicklungen zu Atomkraft in der Schweiz und weltweit auf der gr\xF6ssten nuklearen Informationsplattform des Nuklearforums.",
      imageAlt: "Blick ins Wasser des Reaktorbeckens"
    },
    hub: {
      loading: "Inhalte werden geladen...",
      "no-content-found": "Keine Inhalte gefunden.",
      "focus-title": "Im Fokus"
    },
    companies: {
      "company-name": "Firmenname",
      industry: "Branche",
      search: "Suchen",
      "no-result": "F\xFCr diese Suchkriterien liegen keine Ergebnisse vor.",
      all: "Alle"
    },
    "kernwissen-tag-lists": {
      title: "Kernwissen",
      description: "Entdecken Sie unser \xABKernwissen\xBB, das die Grundlagen der Atomkraft verst\xE4ndlich erkl\xE4rt. Ob Laie oder Interessierter -- hier finden Sie eine klare und zug\xE4ngliche Einf\xFChrung in die Welt der Kernenergie. Tauchen Sie ein und gewinnen Sie ein fundiertes Verst\xE4ndnis f\xFCr die grundlegenden Prinzipien, die hinter dieser Energiequelle stehen."
    },
    company: {
      address: "Adresse",
      "other-address": "Weitere Adressen",
      contacts: "Kontaktdaten",
      "additional-info": "Weiterf\xFChrende Informationen",
      member: "Mitglied Nuklearforum",
      yes: "Ja",
      no: "Nein",
      branches: "Branchen / Produkte",
      website: "Website",
      "other-products": "Andere Produkte",
      meta: {
        description: "Branchenregister der Schweizer Nuklearindustrie"
      }
    },
    teasers: {
      news: "News",
      context: "Kontext",
      podcast: "Podcast",
      video: "Video",
      bulletin: "Bulletin",
      factSheet: "Faktenblatt",
      multimediaDossier: "Multimedia-Dossier",
      event: "Veranstaltung",
      "press-release": "Medienmitteilung",
      topicCollection: "Themenschwerpunkt"
    },
    topics: {
      all: "Alle Eintr\xE4ge"
    },
    pager: {
      previous: "Zur\xFCck",
      next: "Weiter",
      "first-page": "Erste Seite",
      "last-page": "Letzte Seite",
      "current-page": "Seite"
    },
    image: {
      sourceLabel: "Quelle"
    },
    status_messages: {
      content_language_not_available_fr: "Cette page n\u2019est disponible qu\u2019en allemand.",
      content_language_not_available_de: "Diese Seite ist nur auf Franz\xF6sisch verf\xFCgbar."
    },
    ui: {
      contentSourceLabel: "Quelle",
      contentAuthorLabel: "Verfasser/in",
      contentReferencesLabel: "Referenzen",
      contentRelatedArticlesLabel: "Verwandte Artikel",
      contentAttachmentLabel: "Anh\xE4nge",
      contentEventLabel: "Veranstaltungsdetails",
      contentEventStartDate: "Startdatum",
      contentEventEndDate: "Endtermin",
      contentEventLocation: "Lage"
    },
    country: {
      name: {
        de: "Deutschland",
        fr: "Frankreich",
        it: "Italien",
        li: "Liechtenstein",
        lu: "Luxemburg",
        ch: "Schweiz",
        au: "\xD6sterreich"
      }
    },
    "my-topics": {
      title: "Meine Themen",
      subtitle: "Hier haben Sie die M\xF6glichkeit, unsere Beitr\xE4ge nach Ihren Pr\xE4ferenzen individuell zu filtern. Ihre Auswahl bleibt gespeichert, damit Sie bei Ihrem n\xE4chsten Besuch direkt auf die f\xFCr Sie relevanten Themen zugreifen k\xF6nnen.",
      "open-form": "Meine Filter ausw\xE4hlen",
      "reset-form": "Zur\xFCcksetzen",
      "submit-form": {
        result: "{prediction} Ergebnis(se) anzeigen",
        "no-result": "{prediction} Ergebnisse"
      },
      theme: "Themen",
      category: "Art / Format",
      region: "Regionen / L\xE4nder",
      from: "Startdatum",
      to: "Enddatum",
      "no-results": "F\xFCr diese Suchkriterien liegen keine Ergebnisse vor."
    },
    events: {
      title: "Veranstaltungen",
      subtitle: "Reservieren Sie sich bereits heute diese Termine in Ihrer Agenda.",
      upcoming: "Kommende Veranstaltungen",
      past: "Vergangene Veranstaltungen",
      public: "\xD6ffentliche Veranstaltung",
      internal: "Interne Veranstaltung"
    },
    Bulletin: "Bulletin",
    FactSheet: "Fact Sheet",
    MultimediaDossier: "Multimedia-Dossier",
    Video: "Video",
    PressRelease: "Press release",
    News: "News",
    Context: "Kontext",
    Podcast: "Podcast",
    "pre-footer": {
      newsletter: {
        label: "Bleiben Sie auf dem Laufenden",
        title: "Abonnieren Sie unseren Newsletter",
        button: "Zur Newsletter-Anmeldung"
      },
      membership: {
        label: "Profitieren Sie als Mitglied",
        title: "Werden Sie Mitglied im gr\xF6ssten nuklearen Netzwerk der Schweiz!",
        button: "Vorteile einer Mitgliedschaft"
      }
    },
    offering: {
      contract: "Art",
      where: "Wo",
      when: "Ab wann"
    },
    search: {
      "page-title": "Suche",
      "input-placeholder": "Suchen nach",
      "filters-heading": "Filter",
      "reset-button-label": "Suche zur\xFCcksetzen",
      "result-label": "Resultat",
      "result-label-suffix": "e",
      "no-results": "Keine Inhalte gefunden.",
      filters: {
        "type-heading": "Typ",
        "toggle-label": "Filter"
      },
      sort: {
        label: "Sortierung",
        "most-relevant-label": "Relevanteste",
        "most-recent-label": "Neueste"
      }
    },
    cookie_consent: {
      video: {
        overlay_message: "Bitte aktivieren Sie die Cookies, um Videos abzuspielen."
      },
      button: {
        text: "Cookie-Einstellungen",
        preferences_text: "Cookie-Einstellungen anpassen"
      }
    },
    listing_page: {
      PressRelease: {
        title: "Medienmitteilungen"
      },
      Podcast: {
        title: "Podcasts",
        description: "NucTalk ist der Podcast des Nuklearforums Schweiz f\xFCr alle, die sich f\xFCr Nukleartechnologie interessieren. Hier reden wir mit Expertinnen und Experten aus Wissenschaft, Politik und der Nuklearbranche."
      }
    },
    podcast_buttons: {
      listen_on: "Anh\xF6ren auf"
    },
    metaMenu: {
      events: "Veranstaltungen"
    }
  },
  fr: {
    404: {
      headline: "404",
      text: "Page non trouv\xE9e."
    },
    header: {
      "main-menu": "Menu principal",
      home: `Page d'accueil`,
      search: "Recherche",
      "my-themes": "Mes sujets",
      "core-knowledge": "Comprendre le nucl\xE9aire",
      menu: "Menu"
    },
    footer: {
      contact: "Contact",
      company: "Forum nucl\xE9aire suisse",
      address: "Frohburgstrasse 20",
      city: "4600 Olten",
      tel: "+41 31 560 36 50",
      email: "info@nuklearforum.ch",
      copyright: "Forum nucl\xE9aire suisse \xA9 {year}",
      recommendations: "Nos recommandations th\xE9matiques"
    },
    meta: {
      sitename: "Forum nucl\xE9aire suisse",
      title_suffix: "S'informer maintenant",
      title: "Energie nucl\xE9aire et centrale nucl\xE9aire",
      description: "S'informer pour mieux comprendre - Forum nucl\xE9aire suisse",
      imageAlt: "Un coup d'oeil dans la piscine du r\xE9acteur"
    },
    hub: {
      loading: "Chargement du contenu...",
      "no-content-found": "Aucun contenu trouv\xE9.",
      "focus-title": "\xC0 la une"
    },
    companies: {
      "company-name": "Nom de l\u2019entreprise",
      industry: "Secteur",
      search: "Rechercher",
      "no-result": "Il n'y a pas de r\xE9sultats pour ces crit\xE8res de recherche.",
      all: "Tous les secteurs"
    },
    "kernwissen-tag-lists": {
      title: "Comprendre le nucl\xE9aire",
      description: "Gr\xE2ce \xE0 notre nouvelle rubrique \xABComprendre le nucl\xE9aire\xBB, l\u2019\xE9nergie nucl\xE9aire n\u2019aura plus aucun secret pour vous. Celle-ci propose des informations claires et accessibles qui permettront aux personnes curieuses ou int\xE9ress\xE9es d'entrer dans l'univers du nucl\xE9aire. Venez d\xE9couvrir les principes fondamentaux qui se cachent derri\xE8re cette source d'\xE9nergie."
    },
    company: {
      address: "Adresse",
      "other-address": "Adresses suppl\xE9mentaires",
      contacts: "Personne \xE0 contacter",
      "additional-info": "Pour en savoir plus",
      member: "Membre du forum nucl\xE9aire",
      yes: "Oui",
      no: "Non",
      branches: "Secteurs / produits",
      website: "Site Internet",
      "other-products": "Autres produits",
      meta: {
        description: "R\xE9pertoire des entreprises"
      }
    },
    teasers: {
      news: "Nouvelles",
      context: "Contexte",
      podcast: "Podcast",
      video: "Vid\xE9o",
      bulletin: "Bulletin",
      factSheet: "Feuille d\u02BCinformation",
      multimediaDossier: "Dossier multim\xE9dia",
      event: "Manifestation",
      "press-release": "Communiqu\xE9 de presse",
      topicCollection: "Sous la loupe"
    },
    topics: {
      all: "Toutes les entr\xE9es"
    },
    pager: {
      previous: "Pr\xE9c\xE9dent",
      next: "Suivant",
      "first-page": "Premi\xE8re page",
      "last-page": "Derni\xE8re page",
      "current-page": "Page"
    },
    image: {
      sourceLabel: "Source"
    },
    status_messages: {
      content_language_not_available_fr: "Cette page n\u2019est disponible qu\u2019en allemand.",
      content_language_not_available_de: "Diese Seite ist nur auf Franz\xF6sisch verf\xFCgbar."
    },
    ui: {
      contentSourceLabel: "Source",
      contentAuthorLabel: "Auteur",
      contentReferencesLabel: "References",
      contentRelatedArticlesLabel: "Articles sur le m\xEAme th\xE8me",
      contentAttachmentLabel: "Annexe",
      contentEventLabel: `D\xE9tails de l'\xE9v\xE8nement`,
      contentEventStartDate: "date de d\xE9but",
      contentEventEndDate: "date de fin",
      contentEventLocation: "emplacement"
    },
    country: {
      name: {
        de: "Allemagne",
        fr: "France",
        it: "Italie",
        li: "Liechtenstein",
        lu: "Luxembourg",
        ch: "Suisse",
        au: "Autriche"
      }
    },
    "my-topics": {
      title: "Mes sujets",
      subtitle: "Vous avez la possibilit\xE9 de filtrer nos articles selon vos pr\xE9f\xE9rences. Votre s\xE9lection est sauvegard\xE9e afin que vous puissiez acc\xE9der directement \xE0 vos th\xE8mes de pr\xE9dilection lors de votre prochaine visite.",
      "open-form": "S\xE9lectionnez mes filtres",
      "reset-form": "R\xE9initialiser",
      "submit-form": {
        result: "Voir {prediction} r\xE9sultat(s)",
        "no-result": "{prediction} r\xE9sultat"
      },
      theme: "Sujets",
      category: "Type / format",
      region: "R\xE9gions / pays",
      from: "Date de d\xE9but",
      to: "Date de fin",
      "no-results": "Il n'y a pas de r\xE9sultats pour ces crit\xE8res de recherche."
    },
    events: {
      title: "\xC9v\xE8nements",
      subtitle: "R\xE9servez d\xE8s aujourd'hui ces dates dans votre agenda.",
      upcoming: "\xC9v\xE8nements \xE0 venir",
      past: "\xC9v\xE8nements pass\xE9s",
      public: "\xC9v\xE9nement public",
      internal: "\xC9v\xE9nement interne"
    },
    Bulletin: "Bulletin",
    FactSheet: "Fact Sheet",
    MultimediaDossier: "Dossier multim\xE9dia",
    Video: "Video",
    PressRelease: "Press release",
    News: "News",
    Context: "Contexte",
    Podcast: "Podcast",
    "pre-footer": {
      newsletter: {
        label: "Restez inform\xE9-e!",
        title: "Abonnez-vous \xE0 notre newsletter",
        button: "Vers l\u2019abonnement \xE0 la newsletter"
      },
      membership: {
        label: "Profitez de nombreux avantages",
        title: "Devenez membre du plus grand r\xE9seau nucl\xE9aire de Suisse!",
        button: "Les avantages en tant que membre"
      }
    },
    search: {
      "page-title": "Recherche",
      "input-placeholder": "Rechercher",
      "filters-heading": "Filtres",
      "reset-button-label": "R\xE9initialiser la recherche",
      "result-label": "r\xE9sultat",
      "result-label-suffix": "s",
      "no-results": "Aucun contenu trouv\xE9.",
      filters: {
        "type-heading": "Type",
        "toggle-label": "Filtres"
      },
      sort: {
        label: "Tri",
        "most-relevant-label": "Les plus pertinents",
        "most-recent-label": "Les plus r\xE9cents"
      }
    },
    cookie_consent: {
      video: {
        overlay_message: "Veuillez activer les cookies pour lire les vid\xE9os."
      },
      button: {
        text: "Param\xE8tres des cookies",
        preferences_text: "Ajuster les param\xE8tres des cookies"
      }
    },
    listing_page: {
      PressRelease: {
        title: "Communiqu\xE9s de presse"
      },
      Podcast: {
        title: "Podcasts",
        description: "NucTalk, le podcast du Forum nucl\xE9aire suisse, s'adresse \xE0 tous ceux qui s'int\xE9ressent \xE0 la technologie nucl\xE9aire. Nous nous entretenons avec des experts du monde scientifique, politique et de la fili\xE8re nucl\xE9aire."
      }
    },
    podcast_buttons: {
      listen_on: "\xC9couter sur"
    },
    metaMenu: {
      events: "\xC9v\xE8nements"
    }
  }
};

const plainToFlatten = (object) => {
  const result = {};
  function flatten(obj, prefix = "") {
    Object.entries(obj).forEach(([key, value]) => {
      if (typeof value === "object") {
        flatten(value, `${prefix}${key}.`);
      } else {
        result[`${prefix}${key}`] = value;
      }
    });
  }
  flatten(object);
  return result;
};

const useMessages = (locale) => React.useMemo(() => locale && !!translations[locale] ? plainToFlatten(translations[locale]) : {}, [locale]);

const useTranslations = () => {
  const { formatMessage } = reactIntl.useIntl();
  return (id, values, opts) => formatMessage(
    {
      id
    },
    values,
    opts
  );
};

const useLocale = () => {
  const { locale } = reactIntl.useIntl();
  return locale;
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const IntlDecorator = (Story, context) => {
  const {
    globals: { locale }
  } = context;
  const messages = useMessages(locale);
  return /* @__PURE__ */ React__default["default"].createElement(reactIntl.IntlProvider, { defaultLocale: "de", locale, messages }, /* @__PURE__ */ React__default["default"].createElement(Story, __spreadValues({}, context)));
};

const storybookLocale = {
  name: "Locale",
  description: "Internationalization locale",
  defaultValue: "de",
  toolbar: {
    icon: "globe",
    items: Object.values(locales).map(({ code, flag, name }) => ({
      value: code,
      right: flag,
      title: name
    }))
  }
};

exports.IntlDecorator = IntlDecorator;
exports.locales = locales;
exports.normaliseLocalisedDate = normaliseLocalisedDate;
exports.plainToFlatten = plainToFlatten;
exports.storybookLocale = storybookLocale;
exports.translations = translations;
exports.useCurrencies = useCurrencies;
exports.useFormatDate = useFormatDate;
exports.useLocale = useLocale;
exports.useMessages = useMessages;
exports.useTranslations = useTranslations;
Object.keys(reactIntl).forEach(function (k) {
  if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () { return reactIntl[k]; }
  });
});
